import * as Sentry from '@sentry/react'

import { DEFAULT_TAG_COLOR, TAG_COLORS } from './tagging.constants'
import type { TagColor } from './tagging.types'

const TAG_COLOR_MAP: Record<TagColor, { hex: string; border: string }> = {
  blue: { border: '#AFD7FA', hex: '#C7E3FC' },
  gray: { border: '#DEE2E6', hex: '#E9ECEF' },
  green: { border: '#8ECDB5', hex: '#AFDECE' },
  orange: { border: '#F5B94E', hex: '#FDCE84' },
  pink: { border: '#FAACB3', hex: '#FFC7CC' },
  yellow: { border: '#F5E662', hex: '#FAEE82' },
}

export const normalizeTagColor = (color: string): TagColor =>
  TAG_COLORS.find(tagColor => tagColor === color) ?? DEFAULT_TAG_COLOR

const getTagColorEntry = (color: string) => {
  const knownColor = TAG_COLORS.find(tagColor => tagColor === color)

  if (knownColor) {
    return TAG_COLOR_MAP[knownColor]
  }

  Sentry.captureException(
    new Error(
      `getTagColorEntry: unknown tag color returned from the API: ${color}`,
    ),
  )

  return TAG_COLOR_MAP[DEFAULT_TAG_COLOR]
}

export const getTagColorStyles = (color: string) => {
  const colorEntry = getTagColorEntry(color)

  return {
    backgroundColor: colorEntry.hex,
    borderColor: colorEntry.border,
  }
}

export const tagColorToHex = (color: string): string =>
  getTagColorEntry(color).hex

export const tagColorBorder = (color: string): string =>
  getTagColorEntry(color).border
